Flickity.createMethods.push('_createPrevNextCells');

Flickity.prototype._createPrevNextCells = function() {
	this.on('select', this.setPrevNextCells);
};

Flickity.prototype.setPrevNextCells = function() {
	// remove classes
	changeSlideClasses(this.previousSlide, 'remove', 'is-prev');
	changeSlideClasses(this.nextSlide, 'remove', 'is-next');
	// set slides
	this.previousSlide = this.slides[(this.selectedIndex - 1 + this.slides.length) % this.slides.length];
	this.nextSlide = this.slides[(this.selectedIndex + 1 + this.slides.length) % this.slides.length];
	// add classes
	changeSlideClasses(this.previousSlide, 'add', 'is-prev');
	changeSlideClasses(this.nextSlide, 'add', 'is-next');
};

function changeSlideClasses(slide, method, className) {
	if (!slide) {
		return;
	}
	slide.getCellElements().forEach(function(cellElem) {
		cellElem.classList[method](className);
	});
}
class JJMarquee {
	constructor(el, direct = 0) {
		let _offset = this;

		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.item = $(el).children()
		this.total = $(el).children().length / 2
		this.offset = 0;
		this.delta = 0
		this.transform = 0
		this.step = (device == 'mobile') ? 0.4 : 0.8
		this.direct = direct % 2
		this.hover = false

		this.item.each(function(i, el) {
			let marginRight = parseFloat($(el).css('margin-right')) || 0;
			let marginLeft = parseFloat($(el).css('margin-left')) || 0;

			if (marginRight !== 0) {
				_offset.offset = marginRight;
			} else {
				_offset.offset = marginLeft;
			}
		});

		this.run = (this.item.width() + this.offset) * this.total

		if (this.direct == 1) {
			this.wrapper.style.transform = `translate3d(-${this.wrapper.getBoundingClientRect().width / 2}px, 0, 0)`;
			this.transform = -this.wrapper.getBoundingClientRect().width / 2
		}


		// if (device != 'mobile') {
		// 	$(el).hover(() => {
		// 		this.hover = true
		// 	}, () => {
		// 		this.hover = false
		// 	})
		// }
	}

	animate() {
		if (!this.hover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.run;
			}
			this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
		} else {
			if (this.transform > this.run) {
				this.transform = 0;
			}
			this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
		}
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		this.animate();
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}

$(".marquee").each(function(i, el) {
	var $copy = $(el).contents().clone()
	$(el).append($copy)

	var jjMarquee = new JJMarquee(el, i).create()
})
//  --------------------------- jj舊的 end ---------------------------








$(window).on("resize", function() {
	if ($(this).width() > 1200) {
		if (window.device == 'mobile') {
			location.reload()
		}
		window.device = 'desktop';
	} else {
		if (window.device == 'desktop') {
			location.reload()
		}
		window.device = 'mobile';
	}


	if ($(this).width() > 1100 && $(this).width() < 1400 && isIpad()) {
		$("#landscape-lock").removeClass("hidden")
	} else {
		$("#landscape-lock").addClass("hidden")
	}
}).trigger("resize")


// 檢查裝置是否為 iPad
function isIpad() {
	return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
}





if (navigator.appVersion.indexOf("Mac") != -1) {
	$("body").get(0).style.setProperty('--lock', "15px");
} else {
	$("body").get(0).style.setProperty('--lock', "17px");
}






function padLeft(str, len) {
	str = '' + str;
	return str.length >= len ? str : new Array(len - str.length + 1).join("0") + str;
}






function menuHandler(el) {
	$(el).children().on("click", function() {
		$(this).siblings().each(function() {
			$(this).removeClass("current")
		});

		$(this).toggleClass("current")
	})
}



function menuOpen() {
	$("#topmenuWrap").addClass("is-show")
}

function menuClose() {
	$("#topmenuWrap").removeClass("is-show")
}






$("#preload").delay(500).fadeOut(500)







// 選單下滑隱藏 快滾回去時消失
var _scrollLast = 0

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()
	var _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > 200) {
		if (_scrollTop > _scrollLast) {
			$("#fixed-header").removeClass("is-show")
		} else {
			$("#fixed-header").addClass("is-show")
		}
	} else {
		$("#fixed-header").removeClass("is-show")
	}

	_scrollLast = _scrollTop
}).trigger("scroll")









// ryder
function lerp(start, end, amt) {
	return (1 - amt) * start + amt * end
}


class RyderMarquee {
	constructor(el, setting) {
		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.delta = 0
		this.transform = 0
		this.step = 0.5
		this.direct = 0
		this.vertical = false
		this.stopOnHover = false
		this.isHover = false
		this.isAcc = false
		this.acc = 0.5

		Object.assign(this, setting)


		if (device == 'mobile') {
			this.step /= 2
			this.acc /= 2
		}

		if (this.direct == 1) {
			if (!this.vertical) {
				// 橫式
				this.wrapper.style.transform = `translate3d(-${this.rectSize / 2}px, 0, 0)`;
			} else {
				// 直式
				this.wrapper.style.transform = `translate3d(0, -${this.rectSize / 2}px, 0)`;
			}

			this.transform = -this.rectSize / 2 || 0
		}

		if (this.stopOnHover) {
			$(el).hover(() => {
				this.isHover = true
			}, () => {
				this.isHover = false
			})
		}
	}

	animate() {
		this.rectSize = !this.vertical
			? this.wrapper.getBoundingClientRect().width
			: this.wrapper.getBoundingClientRect().height;

		this.delay = 50;

		if (this.velo != null) {
			this.delta = lerp(this.delta, this.scrollY - this.velo, 0.1);
		}

		if (this.delta < 0) {
			this.delta = 0;
		}

		this.velo = this.scrollY;

		clearTimeout(this.timer);

		this.timer = setTimeout(this.clear, this.delay);


		if (!this.isHover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.rectSize / 2;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}

			if (!this.vertical) {
				this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
			} else {
				this.wrapper.style.transform = `translate3d(0, ${this.transform}px, 0)`;
			}
		} else {
			if (this.transform > this.rectSize / 2) {
				this.transform = 0;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}

			if (!this.vertical) {
				this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
			} else {
				this.wrapper.style.transform = `translate3d(0, -${this.transform}px, 0)`;
			}
		}
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		this.animate();
	}

	clear() {
		this.delta = 0;
		this.velo = null;
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}



function marqueeHandler(el, options = {}) {
	const {
		direct = 0, //0是往左 1是往右
		step = null, //移動速度
		stopOnHover = false, //hover時停止
		isAcc = false, //是否滾動時加速
		acc = 0.5, //滾動時的加速度
		vertical = false, //直式
	} = options;

	let $copy = $(el).contents().clone();
	$(el).append($copy);

	let ryderOptions = {
		direct,
		stopOnHover,
		isAcc,
		acc,
		vertical,
	};

	if (step !== null) {
		ryderOptions.step = step;
	}

	let ryderMarquee = new RyderMarquee(el, ryderOptions).create();
}

// 可拖動的跑馬燈
function draggableMarqueeHandler(el, options = {}) {
	const {
		stopOnHover = false,
		step = 0.5,
	} = options;

	// 複製內容以實現無限循環
	let $copy = $(el).contents().clone();
	$(el).append($copy);

	let isDragging = false;
	let startX = 0;
	let scrollLeft = 0;
	let velocity = 0;
	let lastX = 0;
	let lastTime = Date.now();
	let animationId = null;
	let isHover = false;
	let autoScrollOffset = 0;

	const container = $(el).parent();
	const wrapper = el;

	// 自動滾動動畫
	function autoScroll() {
		if (!isDragging && !isHover) {
			autoScrollOffset += step;
			const maxScroll = wrapper.scrollWidth / 2;
			if (autoScrollOffset >= maxScroll) {
				autoScrollOffset = 0;
			}
			wrapper.style.transform = `translate3d(-${autoScrollOffset}px, 0, 0)`;
		}
		animationId = requestAnimationFrame(autoScroll);
	}

	// 開始拖動
	function handleDragStart(e) {
		isDragging = true;
		startX = e.pageX || e.touches[0].pageX;
		scrollLeft = autoScrollOffset;
		velocity = 0;
		lastX = startX;
		lastTime = Date.now();
		$(wrapper).css('cursor', 'grabbing');
	}

	// 拖動中
	function handleDragMove(e) {
		if (!isDragging) return;
		e.preventDefault();

		const x = e.pageX || e.touches[0].pageX;
		const walk = (x - startX);
		const currentTime = Date.now();
		const timeDelta = currentTime - lastTime;

		if (timeDelta > 0) {
			velocity = (x - lastX) / timeDelta;
		}

		lastX = x;
		lastTime = currentTime;

		autoScrollOffset = scrollLeft - walk;
		const maxScroll = wrapper.scrollWidth / 2;

		// 循環邊界
		if (autoScrollOffset < 0) {
			autoScrollOffset += maxScroll;
			scrollLeft += maxScroll;
		} else if (autoScrollOffset >= maxScroll) {
			autoScrollOffset -= maxScroll;
			scrollLeft -= maxScroll;
		}

		wrapper.style.transform = `translate3d(-${autoScrollOffset}px, 0, 0)`;
	}

	// 結束拖動
	function handleDragEnd() {
		if (!isDragging) return;
		isDragging = false;
		$(wrapper).css('cursor', 'grab');

		// 慣性滾動
		function inertia() {
			if (Math.abs(velocity) > 0.01 && !isDragging) {
				autoScrollOffset -= velocity * 30;
				const maxScroll = wrapper.scrollWidth / 2;

				if (autoScrollOffset < 0) {
					autoScrollOffset += maxScroll;
				} else if (autoScrollOffset >= maxScroll) {
					autoScrollOffset -= maxScroll;
				}

				wrapper.style.transform = `translate3d(-${autoScrollOffset}px, 0, 0)`;
				velocity *= 0.95; // 阻力
				requestAnimationFrame(inertia);
			}
		}
		inertia();
	}

	// 滑鼠事件
	$(wrapper).on('mousedown', handleDragStart);
	$(document).on('mousemove', handleDragMove);
	$(document).on('mouseup', handleDragEnd);

	// 觸控事件
	$(wrapper).on('touchstart', handleDragStart);
	$(document).on('touchmove', handleDragMove);
	$(document).on('touchend', handleDragEnd);

	// Hover 停止
	if (stopOnHover) {
		$(wrapper).hover(
			() => { isHover = true; },
			() => { isHover = false; }
		);
	}

	// 防止圖片被拖動
	$(wrapper).find('img').on('dragstart', (e) => e.preventDefault());

	// 設置游標樣式
	$(wrapper).css('cursor', 'grab');

	// 開始自動滾動
	autoScroll();
}




function ryderEnter() {
	$("[data-enter]").each((i, el) => {
		let customOffset = $(el).data('enter') || 0.2;

		let ob_offset = $(window).height() * -customOffset;

		let observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-enter');
				} else {
					// if (!$(entry.target).hasClass('enter-once')) {
					// 	entry.target.classList.remove('is-enter');
					// }
				}
			});
		}, {
			root: null,
			rootMargin: `0px 0px ${ob_offset}px 0px`,
			threshold: 0
		});

		observer.observe(el);
	});
}


gsap.delayedCall(0.5, () => {
	ryderEnter()
});


$(window).on("load", function() {
	ryderEnter()
})
// ryder